import { useRef, useEffect } from "react";

const CANVAS_WIDTH = 438;
const CANVAS_HEIGHT= 35;

function animateBars(analyser: any, canvas: any, canvasCtx: any, dataArray: any, bufferLength: any) {
  analyser.getByteFrequencyData(dataArray);
  canvasCtx.fillStyle = "#000";

  const HEIGHT = canvas.height ;
  var barWidth = Math.ceil(canvas.width / bufferLength) * 2.5;
  let barHeight;
  let x = 0;

  for (var i = 0; i < bufferLength; i++) {
    barHeight = (dataArray[i] / 255) * HEIGHT;
    var gradian = canvasCtx.createLinearGradient(0, HEIGHT * 0.8, 0, 0);
    gradian.addColorStop(1,"#E2369B");
    gradian.addColorStop(0,"#20354C");
    canvasCtx.fillStyle = gradian;
    canvasCtx.fillRect(x, (HEIGHT - barHeight)/2, barWidth, barHeight);

    x += barWidth + 2;
  }
}

const WaveForm = (props: any) => {
  const canvasRef = useRef<any>(null);
  const dataArray = props.analyzerData.dataArray;
  const analyzer = props.analyzerData.analyzer;
  const bufferLength = props.analyzerData.bufferLength;

  const draw = (dataArray: any, analyzer: any, bufferLength: any) => {
    const canvas = canvasRef.current;
    if (!canvas || !analyzer) return;
    const canvasCtx = canvas.getContext("2d");

    const animate = () => {
      requestAnimationFrame(animate);
      // eslint-disable-next-line no-self-assign
      canvas.width = canvas.width;
      canvasCtx.translate(0, 0);
      animateBars(analyzer, canvas, canvasCtx, dataArray, bufferLength);
    };

    animate();
  };

  useEffect(() => {
    draw(dataArray, analyzer, bufferLength);
  }, [dataArray, analyzer, bufferLength]);

  return (
    <canvas
      className='system-check-microphone-visualizer'
      ref={canvasRef}
      width={CANVAS_WIDTH}
      height={CANVAS_HEIGHT}
      
    />
  );
};

export default WaveForm;